// Copyright (c) 2020 Deere & Company

import actions from '../actions-list';

export const updateDealerLaborRateAccounts = (dealer, isSelected) =>
    dispatch => {

        dispatch({
            dealer,
            isSelected,
            type: actions.UPDATE_SELECTED_DEALER_ACCOUNTS
        });

    };

export const toggleAllAccounts = dealers =>
    dispatch => {

        dispatch({
            dealers,
            type: actions.UPDATE_SELECTED_ALL_DEALER_ACCOUNTS
        });

    };

export const resetSelectedDealer = () => ({

    type: actions.RESET_CLAIM_SELECTED_DEALERS

});



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/action-creators/dealers-selected.js